import React from 'react';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button'
//import Cells from './Cells'


/*
  window.Office homepage

  // import office-jfc
      <PrimaryButton text="Generate Report" onClick={e => insertWordTable(selectedAssessment)} />
      <PrimaryButton text="Generate Report" onClick={e => generateReport(assessment) } />   

      {cps ? Object.keys(cps).map(key => <div>{cps[key].name}</div>) : ''}
    firebase.firestore().collection('assessmentsByRater').doc(this.state.assessment.id).get()
*/

export default class Report extends React.Component {

    constructor(props) {
      super(props)
      this.props = props


      const Office = window.Office   
      if (Office) Office.initialize = this.handleOfficeInitialize.bind(this)
      
      this.state = { status: 'initializing', debug: false, cps: []}
    }
  


    handleOfficeInitialize(reason) {
      console.log(reason) 
      this.setState({status: reason})
    }   
    
    renderActivity(activity) {
      return activity.data.competencies.map(cp => cp.get().then(doc => { const data = doc.data(); console.log(data) } ))
    }

    render() { 
        const {status, debug} = this.state

        const {selectedAssessment,generateAssessments, generateWithShowCount,asyncMessage, load,
          summarizedCps} = this.props
    //status == 'inserted' && 
        return <div>
        {selectedAssessment && selectedAssessment.id
                ? <div>
                  {/*<Cells cellCount={9} />*/}
          
          <PrimaryButton text="Generate Report"
            onClick={(e) => generateAssessments(selectedAssessment)} />
          <PrimaryButton text="Generate Report with counter"
            onClick={generateWithShowCount} />       
          
                      <PrimaryButton text='load' onClick={load}  />

                      {asyncMessage}
            {debug ? selectedAssessment.id : ''}
                </div>
                : ''}
        </div>


    }
}


// WEBPACK FOOTER //
// ./src/assessments/components/Report.js